/** @jsxImportSource @emotion/react */
import { FC } from 'react'

import Loader from 'components/Loader'
import * as classes from './styles'

type Props = {
  className?: string
}

export const PageLoader: FC<Props> = (props) => <Loader css={classes.loader} {...props} />
